module.exports = __webpack_public_path__ + "files/9d5df8f6a21af0f669d7555bca51c6f8.png";